import { Component, Input, OnInit } from '@angular/core';
import { CodeAndPhoneValidationLogic } from './code-phone.class';
import { AppIpInfoService } from '@shared/ui-components/au-phone-input/app-ip-info.service';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { AsyncPipe } from '@angular/common';
import { MatOption } from '@angular/material/core';
import { NgxMaskDirective } from 'ngx-mask';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'au-phone-input[formGroup]',
	templateUrl: './au-phone-input.component.html',
	styleUrls: ['./au-phone-input.component.scss'],
	imports: [
		ReactiveFormsModule,
		MatFormField,
		MatLabel,
		MatInput,
		MatAutocompleteTrigger,
		MatAutocomplete,
		MatOption,
		MatError,
		NgxMaskDirective,
		AsyncPipe,
		NgxTolgeeModule,
	],
})
export class AuPhoneNumberComponent
	extends CodeAndPhoneValidationLogic
	implements OnInit
{
	@Input() codeIsReadOnly = false;
	@Input() phoneIsReadOnly = false;
	@Input() formGroup: UntypedFormGroup;
	@Input() countryCode = '';
	@Input() phoneNameAlias = 'phone';

	constructor(protected appIpInfoService: AppIpInfoService) {
		super(appIpInfoService);
	}

	floatLabelConfig = 'always';

	ngOnInit() {
		this.profileForm = this.formGroup;
		this.startProcessingCodeAndPhone();
		if (!this.profileForm.value.countryCode) {
			this.profileForm.patchValue({ countryCode: '+47' });
		}
	}
}
